import Servizi from "../../../../src/fragments/servizi";
import * as React from 'react';
export default {
  Servizi,
  React
};